import { useHttp } from '@/api'
import { httpApi } from '@/api/api'

/**
 * 削除請求台帳情報
 */
export function deleteRequestInfo(data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.DeleteRequestInfo, data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 請求台帳情報の取得
 */
export function getRequestBasicInfo(data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.GetRequestBasicInfo,data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 請求画面選択情報の取得
 */
export function getRequestSelectInfo() {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.GetRequestSelectInfo)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 請求詳細画面情報の取得
 */
export function getRequestDetailInfoByNo(data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.GetRequestDetailInfoByNo,data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 請求詳細画面情報の新規作成
 */
export function creatRequestData(data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.CreatRequestData,data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 請求詳細画面情報の更新
 */
export function changeRequestData(data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.ChangeRequestData,data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 請求製品情報の取得
 */
export function getReqProductInfo(data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.GetReqProductInfo,data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 請求詳細画面情報の取得
 */
export function getReqDetailInfo(data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.GetReqDetailInfo,data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}
// ADD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
/**
 * 請求補足データ選択検索
 */
export function searchSuppSelectInfo(data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.SearchSuppSelectInfo,data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}
/**
 * 請求補足データ⇒詳細画面
 */
export function getReqSuppDetailInfo(data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.GetReqSuppDetailInfo,data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}
// ADD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑







